import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { TbLogout, TbUserCircle } from "react-icons/tb";
import { CloseIcon, HamburgerIcon } from "@chakra-ui/icons";
import { auth } from "../../firebase.js";
import { Routes, Route } from "react-router-dom";

import styles from "./Main.module.css";

import calculators from "./utils/data/calculators.json";
import softwares from "./utils/data/softwares.json";
import tutorials from "./utils/data/tutorials.json";
import updates from "./utils/data/updates.json";

import homepageImage1 from "./utils/img/homepage-1.png";
import homepageImage2 from "./utils/img/homepage-2.png";

import logo from "./utils/img/ars-logo-sem-fundo.png";

import Home from "./pages/Home.js";
import Calculators from "./pages/Calculators";
import Softwares from "./pages/Softwares";
import Tutorials from "./pages/Tutorials";
import Updates from "./pages/Updates";
import Support from "./pages/Support";
import Subscriptions from "./pages/Subscriptions";
import Login from "./pages/Login";
import User from "./pages/User";

import ColorModeButton from "./pages/components/ColorModeButton";

import { useToast } from "@chakra-ui/react";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { FaChevronDown } from "react-icons/fa";

// TEST
// const stripePromise = loadStripe(
//   "pk_test_51QwogSLbZvUnMrGq1DijD23ddx09SrHykqV4ZVmleQzRVyxnwiO2As3OvQstMpjP8g1N1Ipe2KjT4lO4MgjWHf1q00xCKmDjp4"
// );
// REAL
const stripePromise = loadStripe(
  "pk_live_51QwogSLbZvUnMrGqGDv2sK47uxv1h9QS2m77yQmGVpSl5fgk46RM1tYrhOL0Pi7JJzsNRCS8AIi6ZOTwEl7NwsUP00DfFSVybY"
);

function Main({ userInputs, updateUserInputs }) {
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast();
  const [selectedTab, setSelectedTab] = useState("Home");
  const [menuOpen, setMenuOpen] = useState(false);
  const [popupOpen, setPopupOpen] = useState("");
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const popupRef = useRef(null);
  const [popupSelected, setPopupSelected] = useState("");
  const tutorialsRef = useRef(null);
  const updatesRef = useRef(null);
  const userRef = useRef(null);
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");
  const urlParams = new URLSearchParams(window.location.search);
  const [resetPasswordToken, setResetPasswordToken] = useState("");

  function handleTabClick(tab) {
    if (menuOpen) {
      setMenuOpen(false);
    }
    if (tab === "Home") {
      navigate("/");
    } else {
      navigate(`/${tab.toLowerCase()}`);
    }
  }

  function handleTabEnter(tab) {
    let buttonRef;
    if (tab === "tutoriais") buttonRef = tutorialsRef;
    else if (tab === "atualizacoes") buttonRef = updatesRef;
    else if (tab === "usuario") buttonRef = userRef;
    const rect = buttonRef.current.getBoundingClientRect();
    setPopupPosition({
      top: rect.bottom,
      left: rect.left,
    });
    setPopupOpen((prev) => (prev === tab ? "" : tab));
  }

  function handlePopupClick(tab, option) {
    setPopupSelected(option);
    handleTabClick(tab);
  }

  function getSoftwareNavigate(software) {
    {
      /* Fixed because of database shutdown */
    }
    if (userInputs["id"] === null) {
      navigate("/login");
    } else {
      if (software === "FundArs") {
        navigate(softwares[software]["navigate"]);
      } else if (software === "Complas") {
        let license = false;
        if (userInputs["licenses"]["complas"]["plan"] !== "trial") {
          license = true;
        }
        if (license) {
          navigate(softwares[software]["navigate"]);
        } else {
          toast({
            title: "Você não possui uma licença para esse programa",
            status: "warning",
            isClosable: true,
          });
        }
      } else {
        navigate(softwares[software]["navigate"]);
      }
    }
  }

  function logout() {
    auth.signOut().then(() => {
      updateUserInputs("id", null);
      updateUserInputs("name", "");
      updateUserInputs("email", "");
      updateUserInputs("licenses", {});
      navigate("/");
      setPopupSelected("");
    });
  }

  useEffect(() => {
    setSelectedTab(location.pathname.split("/")[1]);
  }, [location]);

  return (
    <div className={`${menuOpen ? styles.menuOpenBodyHome : styles.bodyHome}`}>
      {/* Header */}
      <header className={styles.header}>
        <div className={styles.headerLeft}>
          <div
            className={styles.logo}
            onClick={() => {
              handleTabClick("Home");
              setPopupSelected("");
            }}
          >
            <img className={styles.logoImage} src={logo}></img>
            <h1>
              Engenh<span>Ars</span>
            </h1>
          </div>
          <div className={`${menuOpen ? styles.tabsOpen : styles.tabs}`}>
            <button
              className={
                selectedTab === "calculadoras"
                  ? `${styles.tab} ${styles.selected}`
                  : styles.tab
              }
              onClick={() => {
                handleTabClick("calculadoras");
                setPopupSelected("");
              }}
            >
              Calculadoras
            </button>
            <button
              className={
                selectedTab === "programas"
                  ? `${styles.tab} ${styles.selected}`
                  : styles.tab
              }
              onClick={() => {
                handleTabClick("programas");
                setPopupSelected("");
              }}
            >
              Programas
            </button>
            <button
              ref={tutorialsRef}
              className={
                selectedTab === "tutoriais"
                  ? `${styles.tab} ${styles.selected}`
                  : styles.tab
              }
              onClick={() => handleTabEnter("tutoriais")}
            >
              Tutoriais
              <FaChevronDown
                className={
                  popupOpen === "tutoriais" ? styles.arrowOpen : styles.arrow
                }
              />
              {popupOpen === "tutoriais" && (
                <div
                  ref={popupRef}
                  className={styles.popup}
                  style={
                    window.innerWidth > 1000
                      ? { top: popupPosition.top, left: popupPosition.left }
                      : { top: popupPosition.top - 75 }
                  }
                >
                  <ul>
                    {Object.keys(tutorials).map((item, index) => (
                      <li
                        key={index}
                        onClick={() => handlePopupClick("tutoriais", item)}
                        className={
                          selectedTab === "tutoriais" && popupSelected === item
                            ? styles.popupItemSelected
                            : styles.popupItem
                        }
                      >
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </button>
            <button
              ref={updatesRef}
              className={
                selectedTab === "atualizacoes"
                  ? `${styles.tab} ${styles.selected}`
                  : styles.tab
              }
              onClick={() => handleTabEnter("atualizacoes")}
            >
              Atualizações
              <FaChevronDown
                className={
                  popupOpen === "atualizacoes" ? styles.arrowOpen : styles.arrow
                }
              />
              {popupOpen === "atualizacoes" && (
                <div
                  ref={popupRef}
                  className={styles.popup}
                  style={
                    window.innerWidth > 1000
                      ? { top: popupPosition.top, left: popupPosition.left }
                      : { top: popupPosition.top - 75 }
                  }
                >
                  <ul>
                    {Object.keys(tutorials).map((item, index) => (
                      <li
                        key={index}
                        onClick={() => handlePopupClick("atualizacoes", item)}
                        className={
                          selectedTab === "atualizacoes" &&
                          popupSelected === item
                            ? styles.popupItemSelected
                            : styles.popupItem
                        }
                      >
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </button>
            <button
              className={
                selectedTab === "assinaturas"
                  ? `${styles.tab} ${styles.selected}`
                  : styles.tab
              }
              onClick={() => {
                handleTabClick("assinaturas");
                setPopupSelected("");
              }}
            >
              Assinaturas
            </button>
            <button
              className={
                selectedTab === "suporte"
                  ? `${styles.tab} ${styles.selected}`
                  : styles.tab
              }
              onClick={() => {
                handleTabClick("suporte");
                setPopupSelected("");
              }}
            >
              Perguntas Frequentes
            </button>
            {userInputs["id"] !== null ? (
              <div className={styles.mobileTabUser}>
                <TbUserCircle
                  onClick={() => handlePopupClick("usuario", "Info")}
                  color="var(--primary-color)"
                  size={30}
                />
                <span onClick={() => handlePopupClick("usuario", "Info")}>
                  {userInputs["name"]}
                </span>
                <TbLogout color="red" size={30} onClick={logout} />
              </div>
            ) : (
              <button
                className={styles.mobileTabLogin}
                onClick={() => {
                  handleTabClick("login");
                }}
              >
                Entrar
              </button>
            )}
          </div>
        </div>
        <div className={styles.headerRight}>
          {/* Fixed because of database shutdown */}
          {userInputs["id"] !== null ? (
            <div
              ref={userRef}
              className={styles.tabUser}
              onClick={() => handleTabEnter("usuario")}
            >
              <TbUserCircle size={30} />
              <span>{userInputs["name"]}</span>
              <FaChevronDown
                className={
                  popupOpen === "usuario" ? styles.arrowOpen : styles.arrow
                }
              />
              {popupOpen === "usuario" && (
                <div
                  ref={popupRef}
                  className={styles.popup}
                  style={{ top: popupPosition.top, left: popupPosition.left }}
                >
                  <ul>
                    <li
                      onClick={() => handlePopupClick("usuario", "Info")}
                      className={
                        popupSelected === "Info"
                          ? styles.popupItemSelected
                          : styles.popupItem
                      }
                    >
                      Minha Conta
                    </li>
                    <li onClick={logout} className={styles.popupItem}>
                      Sair
                    </li>
                  </ul>
                </div>
              )}
            </div>
          ) : (
            <button
              className={styles.tabLogin}
              onClick={(e) => {
                handleTabClick("login");
                handleTabEnter(e, "");
              }}
            >
              Entrar
            </button>
          )}
          <button
            className={styles.mobileMenu}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <CloseIcon /> : <HamburgerIcon />}
          </button>
          <ColorModeButton />
        </div>
      </header>
      {/* Section */}
      <main className={`${menuOpen ? styles.hideMain : styles.mainHome}`}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/calculadoras/*"
            element={
              <Calculators
                calculators={calculators}
                getSoftwareNavigate={getSoftwareNavigate}
              />
            }
          />
          <Route
            path="/programas"
            element={
              <Softwares
                softwares={softwares}
                getSoftwareNavigate={getSoftwareNavigate}
              />
            }
          />
          <Route
            path="/tutoriais"
            element={
              <Tutorials tutorials={tutorials} popupSelected={popupSelected} />
            }
          />
          <Route
            path="/atualizacoes"
            element={
              <Updates updates={updates} popupSelected={popupSelected} />
            }
          />
          <Route
            path="/assinaturas"
            element={
              <Elements stripe={stripePromise}>
                <Subscriptions userInputs={userInputs} />
              </Elements>
            }
          />
          <Route path="/suporte" element={<Support />} />
          <Route
            path="/login"
            element={<Login updateUserInputs={updateUserInputs} />}
          />
          <Route
            path="/usuario"
            element={
              <Elements stripe={stripePromise}>
                <User userInputs={userInputs} popupSelected={popupSelected} />
              </Elements>
            }
          />
        </Routes>
      </main>
      {/* Footer */}
      <footer className={styles.footer}>
        <a
          // href="https://github.com/FelipeDieguez"
          target="_blank"
        >
          {/* <i className="fab fa-github"></i> */}
        </a>
        <a href="https://www.instagram.com/engenhars_/" target="_blank">
          <i className="fab fa-instagram"></i>
        </a>
        <a href="https://www.youtube.com/@EngenhArs" target="_blank">
          <i className="fab fa-youtube"></i>
        </a>
        <a href="https://www.linkedin.com/company/engenhars" target="_blank">
          <i className="fab fa-linkedin"></i>
        </a>
      </footer>
    </div>
  );
}

export default Main;
